import { AppBar, Avatar, Box, Toolbar } from '@mui/material';
import { palette, UsersOutlineIcon } from '@silbo/ui';
import { useState } from 'react';
import logo from '../../../assets/images/logo.svg';
import ProfileDialog from './ProfileDialog';

const AVATAR_SIZE = 32;
const LOGO_HEIGHT = 20;

const TopBar = () => {
  const [profileDialogOpen, setProfileDialogOpen] = useState(false);

  return (
    <>
      <AppBar
        position="sticky"
        sx={{ top: 0, backgroundColor: palette.background.default, paddingTop: 'env(safe-area-inset-top)' }}
        elevation={2}
      >
        <Toolbar sx={{ position: 'relative' }}>
          <Avatar
            sx={{
              backgroundColor: palette.danger.main,
              width: AVATAR_SIZE,
              height: AVATAR_SIZE,
            }}
            onClick={() => setProfileDialogOpen(true)}
          >
            <UsersOutlineIcon sx={{ fontSize: 16 }} />
          </Avatar>
          <Box
            sx={{
              position: 'absolute',
              left: '50%',
              transform: 'translateX(-50%)',
            }}
          >
            <img src={logo} alt="Logo" height={LOGO_HEIGHT} />
          </Box>
        </Toolbar>
      </AppBar>
      <ProfileDialog open={profileDialogOpen} onClose={() => setProfileDialogOpen(false)} />
    </>
  );
};

export default TopBar;
